// Module
var code = `<template> <div class="page-invalid-country column justify-content-center align-items-middle flex-grow-1"> <span class="title">Country not valid.</span> <p class="subtitle">(\${country})</p> <p class="desc">Onboarding is not available in your country.</p> </div> </template>`;
// Exports
module.exports = code;